<template>
  <app-section theme="nude" class="v2-dmca">
    <div class="row">
      <dmca-text />
    </div>
  </app-section>
</template>

<script setup lang="ts">
import AppSection from "@/components/v2/section/index.vue";
import DmcaText from "@/components/dmca-text/index.vue";

defineOptions({
  name: "dmca-v2",
});
</script>
